let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jWBvv")).then(() => parcelRequire('d85cN'));